<template>
  <article class="flex min-h-80 animate-pulse flex-col rounded-xl border border-charcoal-200 bg-white p-5 sm:p-6 sm:pb-8">
    <div class="flex flex-1 flex-col items-center justify-center gap-4">
      <div class="h-4 w-28 rounded bg-gray-200" />
      <div class="h-7 w-48 max-w-full rounded bg-gray-200" />
      <div class="h-9 w-40 rounded bg-gray-200" />
    </div>

    <div class="mt-5 h-12 w-full rounded bg-gray-200" />

    <div class="flex flex-1 items-start justify-center pt-4">
      <div class="h-4 w-44 max-w-full rounded bg-gray-200" />
    </div>
  </article>
</template>
